(function () {
  'use strict';

  var INDEX_URL = window.YF_CONDITION_OPTIONS_INDEX_URL || '';
  var indexPromise = null;
  var indexRetryAfter = 0;
  var productCache = Object.create(null);
  var productRetryAfter = Object.create(null);
  var scheduled = false;
  var optionsObserver = null;
  var observedCards = new Map();
  var processedMounts = new WeakSet();

  function text(value) {
    return String(value == null ? '' : value).trim();
  }

  function exactPartKey(value) {
    return text(value).toLowerCase();
  }

  function indexPartKey(value) {
    return text(value).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function conditionKey(value) {
    var raw = text(value).toLowerCase();
    if (raw === 'new') return 'new';
    if (raw === 'used') return 'used';
    return '';
  }

  function oppositeCondition(value) {
    var key = conditionKey(value);
    if (key === 'new') return 'used';
    if (key === 'used') return 'new';
    return '';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function plainTextFromHtml(value) {
    var holder = document.createElement('div');
    holder.innerHTML = String(value == null ? '' : value);
    return text(holder.textContent || holder.innerText || '');
  }

  function moneyFromCents(value) {
    var n = Number(value);
    if (!isFinite(n)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return plainTextFromHtml(window.Shopify.formatMoney(n));
    }

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    try {
      if (currency && window.Intl && Intl.NumberFormat) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency
        }).format(n / 100);
      }
    } catch (error) {}

    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }

  function shopifyRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? String(window.Shopify.routes.root)
      : '/';
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function localizedProductUrl(handle, variantId) {
    var url = shopifyRoot() + 'products/' + encodeURIComponent(handle || '');
    var cleanVariantId = idTail(variantId);
    return cleanVariantId ? url + '?variant=' + encodeURIComponent(cleanVariantId) : url;
  }

  function boolish(value) {
    var raw = text(value).toLowerCase();
    return raw === 'true' || raw === '1' || raw === 'yes';
  }

  function idTail(value) {
    var raw = text(value);
    if (!raw) return '';
    return raw.split('/').pop();
  }

  function itemLooksInStock(item) {
    if (!item) return false;
    if (item.available === false) return false;
    if (item.inventory !== '' && item.inventory != null && isFinite(Number(item.inventory)) && Number(item.inventory) <= 0) return false;
    return true;
  }

  function matchingVariant(json, item) {
    if (!json || !Array.isArray(json.variants) || !json.variants.length) return null;
    var wanted = idTail(item && item.variantId);
    if (wanted) {
      return json.variants.find(function (variant) { return idTail(variant && variant.id) === wanted; }) || null;
    }
    return json.variants.find(function (variant) { return variant && variant.available; }) || json.variants[0];
  }

  function liveOnlineInStockItem(item) {
    if (!itemLooksInStock(item)) return Promise.resolve(null);
    return fetchProductJs(item.url || item.handle).then(function (json) {
      if (!json || json.available === false) return null;
      var variant = matchingVariant(json, item);
      if (!variant || variant.available === false) return null;

      item.handle = item.handle || json.handle || getHandleFromUrl(item.url || '');
      item.variantId = variant.id || item.variantId;
      item.url = localizedProductUrl(json.handle || item.handle || getHandleFromUrl(item.url || ''), item.variantId);
      item.title = item.title || json.title || '';
      item.image = item.image || json.featured_image || (Array.isArray(json.images) && json.images[0]) || '';

      // Always replace index/base-market prices with the live Ajax Product API
      // price. Shopify returns this endpoint in the customer's presentment
      // currency, including market-specific fixed pricing.
      item.price = variant.price != null
        ? moneyFromCents(variant.price)
        : (json.price != null ? moneyFromCents(json.price) : '');
      item.compareAtPrice = variant.compare_at_price
        ? moneyFromCents(variant.compare_at_price)
        : (json.compare_at_price ? moneyFromCents(json.compare_at_price) : '');
      item.available = true;
      if (item.inventory === '' && variant.inventory_quantity != null) item.inventory = variant.inventory_quantity;
      return item;
    }).catch(function () {
      return null;
    });
  }

  function closestProductCard(el) {
    if (!el || !el.closest) return null;
    try {
      var exact = el.closest('.\\#product-card');
      if (exact) return exact;
    } catch (err) {}
    try {
      var attr = el.closest('[class*="#product-card"]');
      if (attr) return attr;
    } catch (err2) {}
    try {
      var generic = el.closest('[class*="product-card"]');
      if (generic) return generic;
    } catch (err3) {}
    return el.parentElement || null;
  }

  function ensureStyles() {
    if (document.getElementById('yf-condition-options-runtime-css')) return;
    var style = document.createElement('style');
    style.id = 'yf-condition-options-runtime-css';
    style.textContent = '' +
      '.yf-condition-options{position:relative!important;z-index:999999!important;width:100%!important;margin:.55rem 0 0!important;display:flex!important;justify-content:center!important;align-items:center!important;pointer-events:auto!important;line-height:1!important;text-align:center!important}' +
      '.yf-condition-options[hidden]{display:none!important}' +
      '.yf-condition-options__wrap{position:relative!important;z-index:999999!important;display:grid!important;justify-items:center!important;width:100%!important;gap:.28rem!important;pointer-events:auto!important}' +
      '.yf-condition-options__toggle{appearance:none!important;-webkit-appearance:none!important;position:relative!important;z-index:1000000!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:.24rem!important;min-height:24px!important;padding:.28rem .56rem!important;border:0!important;border-radius:999px!important;background:#ed0000!important;color:#fff!important;font-size:.62rem!important;font-weight:900!important;letter-spacing:0!important;line-height:1!important;text-decoration:none!important;white-space:nowrap!important;cursor:pointer!important;box-shadow:0 3px 8px rgba(237,0,0,.18)!important;pointer-events:auto!important;-webkit-tap-highlight-color:transparent!important}' +
      '.yf-condition-options__toggle:hover,.yf-condition-options__toggle:focus-visible{background:#d90000!important;color:#fff!important;box-shadow:0 4px 10px rgba(237,0,0,.24)!important}' +
      '.yf-condition-options__toggle-text,.yf-condition-options__toggle-icon{color:#fff!important;pointer-events:none!important}' +
      '.yf-condition-options__toggle-icon{font-size:.72em!important;line-height:1!important;transition:transform 160ms ease!important}' +
      '.yf-condition-options__wrap[data-open="true"] .yf-condition-options__toggle-icon{transform:rotate(180deg)!important}' +
      '.yf-condition-options__panel{position:absolute!important;z-index:1000002!important;top:calc(100% + 6px)!important;left:50%!important;right:auto!important;bottom:auto!important;transform:translateX(-50%)!important;display:grid!important;gap:.44rem;width:min(300px,calc(100vw - 30px))!important;margin:0!important;padding:.56rem!important;border:1px solid rgba(237,0,0,.12)!important;border-radius:16px!important;background:#fff!important;box-shadow:0 12px 28px rgba(15,23,42,.18)!important;pointer-events:auto!important;text-align:left!important;max-height:none!important;overflow:visible!important}' +
      '.yf-condition-options__panel[hidden]{display:none!important}' +
      '.yf-condition-options__panel-head{display:flex!important;justify-content:center!important;color:#ed0000!important;font-size:.58rem!important;font-weight:950!important;letter-spacing:.06em!important;line-height:1!important;text-transform:uppercase!important}' +
      '.yf-condition-options__list{display:grid!important;gap:.42rem!important}' +
      '.yf-condition-options__item{position:relative!important;z-index:1000003!important;display:grid!important;grid-template-columns:52px minmax(0,1fr)!important;gap:.48rem!important;align-items:center!important;min-height:62px!important;padding:.42rem!important;border:1px solid rgba(15,23,42,.08)!important;border-radius:13px!important;background:#fff!important;color:#111827!important;text-align:left!important;text-decoration:none!important;box-shadow:0 4px 12px rgba(15,23,42,.06)!important;pointer-events:auto!important}' +
      '.yf-condition-options__image{display:flex!important;align-items:center!important;justify-content:center!important;width:52px!important;height:52px!important;border-radius:10px!important;overflow:hidden!important;background:#f4f4f5!important;color:#888!important;font-size:.52rem!important;font-weight:800!important;text-align:center!important}' +
      '.yf-condition-options__image img{width:100%!important;height:100%!important;object-fit:contain!important}' +
      '.yf-condition-options__info{display:grid!important;gap:.14rem!important;min-width:0!important}' +
      '.yf-condition-options__eyebrow{color:#ed0000!important;font-size:.52rem!important;font-weight:950!important;letter-spacing:.06em!important;line-height:1!important;text-transform:uppercase!important}' +
      '.yf-condition-options__info strong{display:-webkit-box!important;overflow:hidden!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important;color:#111827!important;font-size:.68rem!important;font-weight:900!important;line-height:1.15!important}' +
      '.yf-condition-options__price{color:#ed0000!important;font-size:.78rem!important;font-weight:950!important;line-height:1!important}' +
      '.yf-has-condition-options{overflow:visible!important}' +
      '@media(max-width:749px){.yf-condition-options{margin:.5rem 0 0!important;min-height:22px!important}.yf-condition-options__toggle{min-height:22px!important;padding:.25rem .48rem!important;font-size:.57rem!important;box-shadow:0 2px 6px rgba(237,0,0,.16)!important}.yf-condition-options__wrap{gap:.18rem!important}.yf-condition-options__panel{position:absolute!important;left:50%!important;right:auto!important;bottom:auto!important;top:calc(100% + 5px)!important;transform:translateX(-50%)!important;width:min(280px,calc(100vw - 28px))!important;max-height:none!important;overflow:visible!important;border-radius:15px!important;padding:.5rem!important;box-shadow:0 10px 24px rgba(15,23,42,.16)!important}.yf-condition-options__panel:before{content:none!important}.yf-condition-options__item{grid-template-columns:48px minmax(0,1fr)!important;min-height:58px!important;padding:.38rem!important}.yf-condition-options__image{width:48px!important;height:48px!important}.yf-condition-options__info strong{font-size:.66rem!important}.yf-condition-options__price{font-size:.74rem!important}}' +
      '@media(max-width:749px){.yf-condition-options-mobile-row{position:relative!important;z-index:1000001!important;display:block!important;grid-column:1/-1!important;flex:0 0 100%!important;box-sizing:border-box!important;width:calc(100% - 16px)!important;max-width:calc(100% - 16px)!important;min-width:0!important;left:auto!important;right:auto!important;top:auto!important;bottom:auto!important;transform:none!important;max-height:none!important;overflow:visible!important;margin:.5rem 8px .2rem!important;padding:.58rem!important;border:1px solid rgba(237,0,0,.12)!important;border-radius:14px!important;background:#fff!important;box-shadow:0 5px 14px rgba(15,23,42,.07)!important;text-align:left!important}.yf-condition-options-mobile-row:before{content:none!important}.yf-condition-options-mobile-row .yf-condition-options__panel-head{margin-bottom:.4rem!important;font-size:.56rem!important;text-align:center!important}.yf-condition-options-mobile-row .yf-condition-options__list{display:grid!important;grid-template-columns:1fr!important;gap:.42rem!important}.yf-condition-options-mobile-row .yf-condition-options__item{display:grid!important;grid-template-columns:68px minmax(0,1fr)!important;align-items:center!important;justify-items:stretch!important;gap:.62rem!important;min-height:76px!important;padding:.5rem!important;border-radius:12px!important;text-align:left!important;background:#fff!important;box-shadow:none!important}.yf-condition-options-mobile-row .yf-condition-options__image{width:68px!important;height:68px!important;border-radius:10px!important}.yf-condition-options-mobile-row .yf-condition-options__info{justify-items:start!important;text-align:left!important}.yf-condition-options-mobile-row .yf-condition-options__eyebrow{font-size:.5rem!important}.yf-condition-options-mobile-row .yf-condition-options__info strong{display:block!important;overflow:visible!important;font-size:.7rem!important;line-height:1.22!important;-webkit-line-clamp:unset!important;-webkit-box-orient:initial!important;white-space:normal!important;word-break:normal!important;overflow-wrap:anywhere!important}.yf-condition-options-mobile-row .yf-condition-options__price{font-size:.72rem!important}.yf-condition-options__wrap[data-open="true"]>.yf-condition-options__panel:not(.yf-condition-options-mobile-row){display:none!important}}' +
      '@media(max-width:390px){.yf-condition-options-mobile-row{width:calc(100% - 12px)!important;max-width:calc(100% - 12px)!important;margin-left:6px!important;margin-right:6px!important;padding:.48rem!important}.yf-condition-options-mobile-row .yf-condition-options__item{grid-template-columns:60px minmax(0,1fr)!important;gap:.52rem!important}.yf-condition-options-mobile-row .yf-condition-options__image{width:60px!important;height:60px!important}}';

    /* YF v85: desktop fix - keep dropdown in normal product-card flow so it does not overlay other desktop products. Mobile behavior is untouched. */
    style.textContent += '' +
      '@media(min-width:750px){.yf-condition-options{position:relative!important;z-index:5!important;margin:.55rem 0 .15rem!important;overflow:visible!important}.yf-condition-options__wrap{position:relative!important;display:grid!important;justify-items:center!important;width:100%!important;overflow:visible!important}.yf-condition-options__wrap[data-open="true"]{z-index:50!important}.yf-condition-options__panel{position:relative!important;z-index:20!important;top:auto!important;left:auto!important;right:auto!important;bottom:auto!important;transform:none!important;width:min(260px,100%)!important;max-width:100%!important;margin:.55rem auto 0!important;padding:.48rem!important;border-radius:14px!important;box-shadow:0 8px 18px rgba(15,23,42,.10)!important;overflow:visible!important;text-align:left!important}.yf-condition-options__panel[hidden]{display:none!important}.yf-condition-options__panel-head{font-size:.55rem!important;margin-bottom:.18rem!important}.yf-condition-options__list{gap:.36rem!important}.yf-condition-options__item{grid-template-columns:48px minmax(0,1fr)!important;gap:.42rem!important;min-height:56px!important;padding:.36rem!important;border-radius:12px!important;box-shadow:none!important}.yf-condition-options__image{width:48px!important;height:48px!important}.yf-condition-options__info strong{font-size:.62rem!important;line-height:1.12!important}.yf-condition-options__price{font-size:.72rem!important}.yf-has-condition-options,.yf-has-condition-options *{overflow:visible!important}}';

    (document.head || document.documentElement).appendChild(style);
  }


  function getHandleFromUrl(urlOrHandle) {
    var raw = text(urlOrHandle);
    var match = raw.match(/\/products\/([^/?#]+)/);
    if (match) return match[1];
    return raw.replace(/^\/+|\/+$/g, '');
  }

  function productUrl(item) {
    var url = text(item.url || item.product_url || '');
    if (url.indexOf('/products/') === 0 || url.indexOf('http') === 0) return url;
    var handle = text(item.handle || url);
    return handle ? '/products/' + handle.replace(/^\/+/, '') : '';
  }

  function loadIndex() {
    if (!INDEX_URL) return Promise.resolve({});
    if (indexRetryAfter > Date.now()) return Promise.resolve({});
    if (!indexPromise) {
      indexPromise = fetch(INDEX_URL, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not load condition options');
          return res.json();
        })
        .then(function (data) {
          var parts = data && (data.parts || data);
          if (!parts || typeof parts !== 'object' || Array.isArray(parts)) throw new Error('Invalid condition options');
          indexRetryAfter = 0;
          return parts;
        })
        .catch(function () {
          indexPromise = null;
          indexRetryAfter = Date.now() + 1000;
          return {};
        });
    }
    return indexPromise;
  }

  function fetchProductJs(url) {
    var handle = getHandleFromUrl(url);
    if (!handle) return Promise.resolve(null);

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? String(window.Shopify.currency.active)
      : '';
    var cacheKey = shopifyRoot() + '|' + currency + '|' + handle;

    if (productRetryAfter[cacheKey] > Date.now()) return Promise.resolve(null);
    if (!productCache[cacheKey]) {
      // Locale-aware Ajax URLs are required so Shopify applies the active
      // language, country/market and presentment currency consistently.
      var endpoint = shopifyRoot() + 'products/' + encodeURIComponent(handle) + '.js';
      productCache[cacheKey] = fetch(endpoint, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (res.status === 404) return null;
          if (!res.ok) throw new Error('Could not check condition product');
          return res.json().then(function (data) {
            if (!data || typeof data !== 'object' || !Array.isArray(data.variants)) throw new Error('Invalid condition product');
            delete productRetryAfter[cacheKey];
            return data;
          });
        })
        .catch(function () {
          delete productCache[cacheKey];
          productRetryAfter[cacheKey] = Date.now() + 1000;
          return null;
        });
    }
    return productCache[cacheKey];
  }

  function itemFromMount(el) {
    return {
      id: text(el.getAttribute('data-product-id')),
      variantId: text(el.getAttribute('data-variant-id')),
      url: text(el.getAttribute('data-product-url')),
      handle: text(el.getAttribute('data-product-handle')),
      title: text(el.getAttribute('data-product-title')),
      image: text(el.getAttribute('data-product-image')),
      price: text(el.getAttribute('data-product-price')),
      compareAtPrice: text(el.getAttribute('data-product-compare-at-price')),
      available: boolish(el.getAttribute('data-product-available')),
      inventory: text(el.getAttribute('data-product-inventory')),
      partNumber: text(el.getAttribute('data-part-number')),
      partKey: exactPartKey(el.getAttribute('data-part-number')),
      condition: conditionKey(el.getAttribute('data-condition')),
      source: 'page'
    };
  }

  function itemFromIndex(raw) {
    return {
      id: text(raw.id || raw.productId || raw.variantId || raw.handle || raw.url),
      variantId: text(raw.variantId),
      url: productUrl(raw),
      handle: text(raw.handle || getHandleFromUrl(raw.url || '')),
      title: text(raw.title),
      image: text(raw.image || raw.featured_image),
      price: text(raw.price && String(raw.price).indexOf('$') === -1 ? ('$' + String(raw.price).replace(/\.00$/, '')) : raw.price),
      compareAtPrice: text(raw.compareAtPrice),
      available: raw.available !== false,
      inventory: raw.inventory == null ? '' : text(raw.inventory),
      partNumber: text(raw.partNumber),
      partKey: exactPartKey(raw.partNumber),
      condition: conditionKey(raw.condition),
      source: 'index'
    };
  }

  function dedupe(items) {
    var seen = Object.create(null);
    var out = [];
    items.forEach(function (item) {
      var key = item.url || item.id || item.title;
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(item);
    });
    return out;
  }

  function buildPageGroups(mounts) {
    var groups = Object.create(null);
    mounts.forEach(function (el) {
      var item = itemFromMount(el);
      if (!item.partKey || !item.condition) return;
      groups[item.partKey] = groups[item.partKey] || [];
      groups[item.partKey].push(item);
    });
    return groups;
  }

  function findPageMatches(groups, current, targetCondition) {
    return (groups[current.partKey] || []).filter(function (item) {
      if (!itemLooksInStock(item)) return false;
      if (item.condition !== targetCondition) return false;
      if (current.id && item.id === current.id) return false;
      if (current.url && item.url === current.url) return false;
      return true;
    });
  }

  function findIndexMatches(index, current, targetCondition) {
    var lookupKey = indexPartKey(current.partNumber);
    var list = index[lookupKey] || [];
    return list.map(itemFromIndex).filter(function (item) {
      // Keep this exact: after finding the normalized bucket, the actual metafield part number still has to match.
      if (!itemLooksInStock(item)) return false;
      if (item.partKey !== current.partKey) return false;
      if (item.condition !== targetCondition) return false;
      if (current.id && item.id === current.id) return false;
      if (current.url && item.url === current.url) return false;
      return true;
    });
  }

  function hydrate(items) {
    return Promise.all(items.map(liveOnlineInStockItem)).then(function (validated) {
      return validated.filter(Boolean);
    });
  }

  function render(el, items, targetCondition) {
    items = dedupe(items);
    var signature = items.map(function (item) { return item.url || item.id; }).join('|') + '|' + targetCondition;

    if (!items.length) {
      el.innerHTML = '';
      el.hidden = true;
      el.removeAttribute('data-yf-condition-options-ready');
      el.removeAttribute('data-yf-condition-options-signature');
      var emptyCard = closestProductCard(el);
      if (emptyCard) emptyCard.classList.remove('yf-has-condition-options');
      return;
    }

    if (el.getAttribute('data-yf-condition-options-signature') === signature) {
      el.hidden = false;
      return;
    }

    hydrate(items).then(function (hydrated) {
      hydrated = dedupe(hydrated);
      if (!hydrated.length) return render(el, [], targetCondition);

      var label = targetCondition === 'used' ? 'View Used Options' : 'View New Options';
      var optionLabel = targetCondition === 'used' ? 'Used option' : 'New option';
      var countLabel = hydrated.length > 1 ? hydrated.length + ' options available' : '1 option available';
      var html = '<div class="yf-condition-options__wrap" data-yf-condition-options-wrap>' +
        '<button class="yf-condition-options__toggle" type="button" data-yf-condition-options-toggle aria-expanded="false" aria-label="' + escapeHtml(label) + '">' +
          '<span class="yf-condition-options__toggle-text">' + escapeHtml(label) + '</span>' +
          '<span class="yf-condition-options__toggle-icon" aria-hidden="true">▾</span>' +
        '</button>' +
        '<div class="yf-condition-options__panel" data-yf-condition-options-panel hidden>' +
          '<div class="yf-condition-options__panel-head">' + escapeHtml(countLabel) + '</div>' +
          '<div class="yf-condition-options__list">';

      hydrated.forEach(function (item) {
        html += '<a class="yf-condition-options__item" href="' + escapeHtml(item.url) + '" data-yf-condition-options-item>';
        if (item.image) {
          html += '<span class="yf-condition-options__image"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></span>';
        } else {
          html += '<span class="yf-condition-options__image yf-condition-options__image--empty">No image</span>';
        }
        html += '<span class="yf-condition-options__info">' +
          '<span class="yf-condition-options__eyebrow">' + escapeHtml(optionLabel) + '</span>' +
          '<strong>' + escapeHtml(item.title) + '</strong>';
        if (item.price) html += '<span class="yf-condition-options__price">' + escapeHtml(item.price) + '</span>';
        html += '</span></a>';
      });

      html += '</div></div></div>';
      el.innerHTML = html;
      el.hidden = false;
      el.setAttribute('data-yf-condition-options-ready', 'true');
      el.setAttribute('data-yf-condition-options-signature', signature);
      var card = closestProductCard(el);
      if (card) card.classList.add('yf-has-condition-options');
    });
  }

  function processMounts(mounts) {
    if (!mounts.length) return;
    var groups = buildPageGroups(Array.prototype.slice.call(document.querySelectorAll('[data-yf-condition-options]')));
    loadIndex().then(function (index) {
      mounts.forEach(function (el) {
        if (!el.isConnected) return;
        var current = itemFromMount(el);
        if (!current.partKey || !current.condition) {
          render(el, [], '');
          return;
        }

        // Only show condition option buttons on New product cards.
        // Used product cards should not show "View New Options" anymore.
        if (current.condition !== 'new') {
          render(el, [], '');
          return;
        }

        var target = 'used';

        var matches = findPageMatches(groups, current, target);
        matches = matches.concat(findIndexMatches(index, current, target));
        render(el, matches, target);
      });
    });
  }

  function processAll() {
    scheduled = false;
    var mounts = Array.prototype.slice.call(document.querySelectorAll('[data-yf-condition-options]'));
    var immediate = [];
    mounts.forEach(function (el) {
      var current = itemFromMount(el);
      if (!current.partKey || current.condition !== 'new') {
        render(el, [], '');
        return;
      }
      if (processedMounts.has(el)) {
        immediate.push(el);
        return;
      }
      var card = closestProductCard(el);
      if (!('IntersectionObserver' in window) || !card) {
        processedMounts.add(el);
        immediate.push(el);
        return;
      }
      if (!optionsObserver) {
        optionsObserver = new IntersectionObserver(function (entries) {
          var visible = [];
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var pending = observedCards.get(entry.target) || [];
            pending.forEach(function (mount) {
              if (!processedMounts.has(mount)) {
                processedMounts.add(mount);
                visible.push(mount);
              }
            });
            observedCards.delete(entry.target);
            optionsObserver.unobserve(entry.target);
          });
          processMounts(visible);
        }, { rootMargin: '300px 0px' });
      }
      var pending = observedCards.get(card) || [];
      if (pending.indexOf(el) === -1) pending.push(el);
      observedCards.set(card, pending);
      optionsObserver.observe(card);
    });
    observedCards.forEach(function (pending, card) {
      if (card.isConnected) return;
      optionsObserver.unobserve(card);
      observedCards.delete(card);
    });
    processMounts(immediate);
  }

  function scheduleProcess() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(processAll, 80);
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }


  function isMobileOptionsLayout() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  function optionOwnerId(wrap) {
    if (!wrap) return '';
    var id = wrap.getAttribute('data-yf-condition-options-owner');
    if (!id) {
      id = 'yfco-' + Math.random().toString(36).slice(2, 10);
      wrap.setAttribute('data-yf-condition-options-owner', id);
    }
    return id;
  }

  function removeMobileRows(exceptOwner) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-yf-condition-options-mobile-row]'), function (row) {
      if (exceptOwner && row.getAttribute('data-yf-condition-options-owner') === exceptOwner) return;
      row.parentNode && row.parentNode.removeChild(row);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.yf-condition-options-open'), function (card) {
      if (exceptOwner && card.getAttribute('data-yf-condition-options-owner') === exceptOwner) return;
      card.classList.remove('yf-condition-options-open');
      card.removeAttribute('data-yf-condition-options-owner');
    });
  }

  function showMobileInlinePanel(wrap, panel) {
    if (!wrap || !panel) return false;
    var owner = optionOwnerId(wrap);
    var card = closestProductCard(wrap);
    var mount = wrap.closest ? wrap.closest('.yf-condition-options') : null;
    if (!card || !mount || !mount.parentNode) return false;

    removeMobileRows(owner);

    var existing = document.querySelector('[data-yf-condition-options-mobile-row][data-yf-condition-options-owner="' + owner + '"]');
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'yf-condition-options__panel yf-condition-options-mobile-row';
      existing.setAttribute('data-yf-condition-options-mobile-row', 'true');
      existing.setAttribute('data-yf-condition-options-owner', owner);
      existing.innerHTML = panel.innerHTML;
    }

    // Put the expanded options panel directly inside the product-card root.
    // The toggle lives in the narrow mobile caption column, which previously
    // constrained this panel and truncated the used-product title. As a direct
    // card child it can span the image and details columns without overflowing
    // the viewport.
    if (existing.parentNode !== card || card.lastElementChild !== existing) {
      card.appendChild(existing);
    }

    existing.hidden = false;
    card.classList.add('yf-condition-options-open');
    card.setAttribute('data-yf-condition-options-owner', owner);
    return true;
  }

  function hideMobileInlinePanel(wrap) {
    var owner = optionOwnerId(wrap);
    removeMobileRows(owner ? null : '');
    if (owner) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-yf-condition-options-mobile-row][data-yf-condition-options-owner="' + owner + '"]'), function (row) {
        row.parentNode && row.parentNode.removeChild(row);
      });
      Array.prototype.forEach.call(document.querySelectorAll('.yf-condition-options-open[data-yf-condition-options-owner="' + owner + '"]'), function (card) {
        card.classList.remove('yf-condition-options-open');
        card.removeAttribute('data-yf-condition-options-owner');
      });
    }
  }

  function closeOtherPanels(activeWrap) {
    var activeOwner = activeWrap ? optionOwnerId(activeWrap) : '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-yf-condition-options-wrap][data-open="true"]'), function (wrap) {
      if (wrap === activeWrap) return;
      wrap.setAttribute('data-open', 'false');
      var toggle = wrap.querySelector('[data-yf-condition-options-toggle]');
      var panel = wrap.querySelector('[data-yf-condition-options-panel]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
    removeMobileRows(activeOwner);
  }

  function handleOptionClick(event) {
    var area = event.target && event.target.closest ? event.target.closest('.yf-condition-options') : null;
    var toggle = event.target && event.target.closest ? event.target.closest('[data-yf-condition-options-toggle]') : null;

    if (toggle) {
      stopEvent(event);
      var wrap = toggle.closest('[data-yf-condition-options-wrap]');
      if (!wrap) return false;
      var panel = wrap.querySelector('[data-yf-condition-options-panel]');
      var isOpen = wrap.getAttribute('data-open') === 'true';
      closeOtherPanels(wrap);
      wrap.setAttribute('data-open', isOpen ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) panel.hidden = true;
      if (isOpen) {
        hideMobileInlinePanel(wrap);
      } else if (isMobileOptionsLayout()) {
        showMobileInlinePanel(wrap, panel);
      } else if (panel) {
        panel.hidden = false;
      }
      return false;
    }

    var optionItem = event.target && event.target.closest ? event.target.closest('[data-yf-condition-options-item]') : null;
    if (optionItem) {
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      return;
    }

    if (area) {
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  }

  function handleOptionPointer(event) {
    var toggle = event.target && event.target.closest ? event.target.closest('[data-yf-condition-options-toggle]') : null;
    if (toggle) stopEvent(event);
  }

  function init() {
    ensureStyles();
    processAll();
    document.addEventListener('pointerdown', handleOptionPointer, true);
    document.addEventListener('mousedown', handleOptionPointer, true);
    document.addEventListener('touchstart', handleOptionPointer, true);
    document.addEventListener('click', handleOptionClick, true);
    var target = document.querySelector('collection-provider') || document.body || document.documentElement;
    if (!target) return;
    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType !== 1) return;
          if ((node.matches && node.matches('[data-yf-condition-options]')) || (node.querySelector && node.querySelector('[data-yf-condition-options]'))) {
            shouldRun = true;
          }
        });
      });
      if (shouldRun) scheduleProcess();
    });
    observer.observe(target, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', scheduleProcess);
    window.addEventListener('resize', function () { removeMobileRows(); closeOtherPanels(null); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
